<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">列印拜訪聯繫函</h3>
        </div>
        <div class="modal-body">
          <div class="warning">
            <ul>
              <li class="text-red">在名單專區/服務、權益/異動後實質接觸明細項目內，查無【應實質接觸】或【未實質接觸】保戶。</li>
              <li>如有疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ this.$store.state.serviceLine }}</li>
            </ul>  
          </div>
          <div class="action text-right">
            <a @click="$emit('close')" class="btn btn-primary">確認</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'NoChangeNotice',
  computed: {
    ...mapGetters(['BaseUrl'])
  },
  data () {
    return {
      checkComfirm: false,
    }
  },
  watch: {
    open () {
      this.checkComfirm = false
    },
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: [ Object , String ],
      default: () =>{
        return {}
      }
    },
  },
  methods:{

  }
}
</script>
